import { render, staticRenderFns } from "./company-edit-modal--supporter.vue?vue&type=template&id=bde75562&scoped=true&"
import script from "./company-edit-modal--supporter.vue?vue&type=script&lang=ts&"
export * from "./company-edit-modal--supporter.vue?vue&type=script&lang=ts&"
import style0 from "./company-edit-modal--supporter.vue?vue&type=style&index=0&id=bde75562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde75562",
  null
  
)

export default component.exports